import { getCognitiveDomain } from '@exam-management/qcontent-management';
import {
  Chip,
  ContentPreviewer,
  Flex,
  ReadonlyField,
  SectionTitle,
  Text,
} from '@shared/components';

import { useQuestionReviewTaskQuestionDetails } from '../../providers';

export default function QuestionPropertiesView() {
  const { question } = useQuestionReviewTaskQuestionDetails();
  const cognitiveDomains = getCognitiveDomain(question.tags);
  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        gap: theme.spacing(4),
      })}
    >
      <SectionTitle title='Properties' />
      <Flex sx={(theme) => ({ gap: theme.spacing(1), flexDirection: 'column' })}>
        <Text variant='body2Semibold'>คุณลักษณะของข้อสอบ (Cognitive Domain)</Text>
        <Flex sx={(theme) => ({ gap: theme.spacing(2) })}>
          {cognitiveDomains.map((domain) => (
            <Chip key={domain.value} label={domain.label} />
          ))}
        </Flex>
      </Flex>
      <ReadonlyField
        label='วัตถุประสงค์การเรียนรู้ (LOS)'
        content={question.learningObjectiveStatement?.tag.name ?? '-'}
      />
      <ReadonlyField
        label='คำอธิบายเฉลย'
        // TODO: handle download image
        content={<ContentPreviewer content={question.solution?.value ?? '-'} />}
      />
      <ReadonlyField
        label='หนังสืออ้างอิง'
        content={<ContentPreviewer content={question.metadata?.reference ?? '-'} />}
      />
    </Flex>
  );
}
